<template>
    <modal name="item-option-modal" class="item-option-modal"
           :width="'60%'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="keymodal_title">
            <div class="out_title">옵션 등록</div>
        </div>
        <div class="item_option_wrap">
            <table class="text_center">
                <colgroup>
                    <col width="200px">
                    <col>
                </colgroup>
                <thead>
                <tr>
                    <th>노출순서</th>
                    <th>옵션명</th>
                    <th>판매상태</th>
                    <th>재고관리</th>
                    <th>재고수량</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                        <div>
                            <el-input
                                placeholder="노출순서를 입력해주세요."
                                v-model="optionSeq"
                                type="number"
                                @change="setData('optionSeq', optionSeq)"
                            />
                        </div>
                        <div>
                            <div class="input_error" v-if="validation.hasError('optionSeq') && optionStatus">{{validation.firstError('optionSeq') }}</div>
                        </div>
                    </td>
                    <td>
                        <div>
                            <el-input
                                placeholder="옵션명을 입력해주세요."
                                v-model="optionName"
                                type="text"
                                @change="setData('optionName', optionName)"
                            />
                            <div class="input_error" v-if="validation.hasError('optionName') && optionStatus">{{validation.firstError('optionName') }}</div>
                        </div>
                    </td>
                    <td>
                        <div>
                            <el-select v-model="optionSelling" @change="setData('optionSelling', optionSelling)">
                                <el-option :value="1" :label="`판매함`"></el-option>
                                <el-option :value="0" :label="`판매안함`"></el-option>
                            </el-select>
                            <div class="input_error" v-if="validation.hasError('optionSelling') && optionStatus">{{validation.firstError('optionSelling') }}</div>
                        </div>
                    </td>
                    <td>
                        <div>
                            <el-select v-model="optionStockUse" @change="checkStockStatus('optionStockUse', optionStockUse)">
                                <el-option :value="1" :label="`사용함`"></el-option>
                                <el-option :value="0" :label="`사용안함`"></el-option>
                            </el-select>
                            <div class="input_error" v-if="validation.hasError('optionStockUse') && optionStatus">{{validation.firstError('optionStockUse') }}</div>
                        </div>
                    </td>
                    <td>
                        <div>
                            <el-input
                                placeholder="수량을 입력해주세요."
                                v-model="optionStock"
                                type="text"
                                @change="setData('optionStock', optionStock)"
                                :disabled="!checkStockUse"
                            />
                            <div class="input_error" v-if="validation.hasError('optionStock') && optionStatus">{{validation.firstError('optionStock') }}</div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="text_center pt20">
                <el-button type="primary" class="out_btn" @click="save()">저장</el-button>
                <el-button type="info" class="out_btn" @click="modalClose()">취소</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import util from '@/mixins/util';
import itemValidator from "../item/ItemValidator";
import EventBus from "../../mixins/event-bus";
export default {
    name: "ItemOptionModal",
    props: {
    },
    mixins: [itemValidator],
    components: {},
    computed: {},
    provide() {
        return {
        }
    },
    data() {
        return {
            optionSeq : '',
            optionName : '',
            optionSelling : '',
            optionStockUse : '',
            optionStock : '',

            optionData : {},
            optionType : '',

            optionStatus : false,
            checkStockUse : false,
            optionIndex : ''
        }
    },
    mounted() {

    },
    methods: {
        handlerBeforeOpen(event) {
            if(!util.isEmpty(event.params) && !util.isEmpty(event.params.data)){
                this.optionData = event.params.data;
            }
            if(!util.isEmpty(event.params) && !util.isEmpty(event.params.type)){
                this.optionType = event.params.type;
            }
            if(!util.isEmpty(event.params) && !util.isEmpty(event.params.index)){
                this.optionIndex = event.params.index;
            }

            this.initData()
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
            this.resetData()
        },
        modalClose() {
            this.$modal.hide('item-option-modal');
        },
        initData(){
          if(!util.isEmpty(this.optionData)){
              this.optionSeq = this.optionData.io_seq
              this.optionName = this.optionData.io_title
              this.optionSelling = this.optionData.io_is_selling
              this.optionStockUse = this.optionData.ios_use ?? 0;
              this.optionStock = this.optionData.ios_stock

              this.checkStockStatus()
          }
        },
        resetData() {
            this.optionSeq = ''
            this.optionName = ''
            this.optionSelling = ''
            this.optionStockUse = ''
            this.optionStock = ''
            this.optionStatus = false;
            this.optionData = {}
            this.optionIndex = ''
        },
        setData(type,value){
            this[type] = value
        },
        checkStockStatus(type,value){
            if(this.optionStockUse == 1){
                this.checkStockUse = true
            }else{
                this.optionStock = ''
                this.checkStockUse = false
            }
            this.setData(type,value)
        },
        runValidator() {
            let validatorArr = ['optionSeq', 'optionName', 'optionSelling', 'optionStockUse','optionStock'];
            this.optionStatus = true
            return this.$validate(validatorArr).then(success => {
                return success
            });
        },
        async save() {
            let validator = await this.runValidator()
            if (!validator) {
                return false;
            }

            if(this.optionType === 'create'){
                this.optionData.status = this.optionType;
                this.optionData.io_seq = this.optionSeq;
                this.optionData.io_title = this.optionName;
                this.optionData.io_is_selling = this.optionSelling;
                if(this.optionStockUse == 1){
                    this.optionData.ios_use = this.optionStockUse;
                    this.optionData.ios_stock = this.optionStock;
                }
                EventBus.$emit('addOptionRow', this.optionData);
                this.modalClose();
            }else{
                this.optionData.status = this.optionType;
                this.optionData.io_seq = this.optionSeq;
                this.optionData.io_title = this.optionName;
                this.optionData.io_is_selling = this.optionSelling;
                this.optionData.ios_use = this.optionStockUse;
                this.optionData.ios_stock = this.optionStock;
                EventBus.$emit('updateOptionRow', this.optionData,this.optionIndex);
                this.modalClose();
            }
        },


    }
}
</script>

<style scoped>

</style>
